import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthService, AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface OrderConfirmationPayload {
  orderCode: string;
  fields: string;
  user: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationService {
  baseSite$: Observable<string> = this.baseService.getActive();
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: AuthService,
    protected userIdService: UserIdService,
    protected baseService: BaseSiteService,
    protected authStorageService: AuthStorageService
  ) {}
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get tokenId(): string {
    let tokenId: string;
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }
  getConfirmationOrder(payload: OrderConfirmationPayload): Observable<any> {
    const params = new HttpParams().set('fields', payload.fields);
    return this.http
      .get(
        // tslint:disable-next-line: max-line-length
        `${this.url}/users/${this.userCurrent}/orders/${payload.orderCode}`,
        {
          params,
          headers: this.headers,
        }
      )
      .pipe(retry(1), catchError(this.errorHandl)); // tslint:disable-line/tslint:disable-line
  }

  getOrderConfirmationConfig(): Observable<any> {
    return this.http
      .get(`../../../public/features/ORDER_CONFIRMATION_FEATURES.json`)
      .pipe(catchError((error: any) => throwError(error)));
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
